export const TYPES = [
  {
    id: 'sleep',
    value: 'sleep',
    label: 'Sleep doctor account',
  },
  {
    id: 'non-sleep',
    value: 'non-sleep',
    label: 'Non-sleep doctor account',
  },
];

export const GENDER_OPTIONS = [
  {
    id: 'male',
    value: 'male',
    label: 'Male',
  },
  {
    id: 'female',
    value: 'female',
    label: 'Female',
  },
];

export const ACCOUNT_STATUSES = [
  {
    id: 'active',
    value: 'active',
    label: 'Active',
  },
  {
    id: 'inactive',
    value: 'inactive',
    label: 'Inactive',
  },
];

export const SPECIALTIES = [
  {
    id: 'medecin-generale',
    value: 'medecin-generale',
    label: '01 MEDECINE GÉNÉRALE',
    selected: true,
  },
  {
    id: 'pulmonologist',
    value: 'pulmonologist',
    label: 'Pulmonologist',
    selected: true,
  },
  {
    id: 'otorhinolaryngologist',
    value: 'otorhinolaryngologist',
    label: 'Otorhinolaryngologist',
    selected: true,
  },
  {
    id: 'neurologist',
    value: 'neurologist',
    label: 'Neurologist',
    selected: true,
  },
  {
    id: 'cardiologist',
    value: 'cardiologist',
    label: 'Cardiologist',
    selected: true,
  },
];

export const INTELLIO_SPECIALTIES = [
  {
    id: '1',
    value: '1',
    label: 'Médecine Générale',
    selected: true,
  },
  {
    id: '2',
    value: '2',
    label: 'Anesthésie-Réanimation',
    selected: true,
  },
  {
    id: '3',
    value: '3',
    label: 'Cardiologie',
    selected: true,
  },
  {
    id: '4',
    value: '4',
    label: 'Chirurgie Générale',
    selected: true,
  },
  {
    id: '5',
    value: '5',
    label: 'Dermatologie et Vénérologie',
    selected: true,
  },
  {
    id: '6',
    value: '6',
    label: 'Radiologie',
    selected: true,
  },
  {
    id: '7',
    value: '7',
    label: 'Gynécologie obstétrique',
    selected: true,
  },
  {
    id: '8',
    value: '8',
    label: 'Gastro-entérologie et Hépatologie',
    selected: true,
  },
  {
    id: '9',
    value: '9',
    label: 'Médecine interne',
    selected: true,
  },
  {
    id: '10',
    value: '10',
    label: 'Neuro-chirurgie',
    selected: true,
  },
  {
    id: '11',
    value: '11',
    label: 'Oto-rhino-laryngologie',
    selected: true,
  },
  {
    id: '12',
    value: '12',
    label: 'Pédiatre',
    selected: true,
  },
  {
    id: '13',
    value: '13',
    label: 'Pneumologie',
    selected: true,
  },
  {
    id: '14',
    value: '14',
    label: 'Rhumatologie',
    selected: true,
  },
  {
    id: '15',
    value: '15',
    label: 'Ophtalmologie',
    selected: true,
  },
  {
    id: '16',
    value: '16',
    label: 'Chirurgie urologique',
    selected: true,
  },
  {
    id: '17',
    value: '17',
    label: 'Neuro-psychiatrie',
    selected: true,
  },
  {
    id: '20',
    value: '20',
    label: 'Réanimation médicale',
    selected: true,
  },
  {
    id: '22',
    value: '22',
    label: 'Spécialiste en médecine générale avec diplôme',
    selected: true,
  },
  {
    id: '23',
    value: '23',
    label: 'Spécialiste en médecine générale reconnu par l’ordre',
    selected: true,
  },
  {
    id: '31',
    value: '31',
    label: 'Rééducation Réadaptation fonctionnelle',
    selected: true,
  },
  {
    id: '32',
    value: '32',
    label: 'Neurologie',
    selected: true,
  },
  {
    id: '33',
    value: '33',
    label: 'Psychiatrie',
    selected: true,
  },
  {
    id: '34',
    value: '34',
    label: 'Gériatrie',
    selected: true,
  },
  {
    id: '35',
    value: '35',
    label: 'Néphrologie',
    selected: true,
  },
  {
    id: '41',
    value: '41',
    label: 'Chirurgie orthopédique et Traumatologie',
    selected: true,
  },
  {
    id: '42',
    value: '42',
    label: 'Endocrinologie et Métabolisme',
    selected: true,
  },
  {
    id: '43',
    value: '43',
    label: 'Chirurgie Infantile',
    selected: true,
  },
  {
    id: '46',
    value: '46',
    label: 'Chirurgie Plastique Reconstructive et Esthétique',
    selected: true,
  },
  {
    id: '47',
    value: '47',
    label: 'Chirurgie Thoracique et Cardio-vasculaire',
    selected: true,
  },
  {
    id: '48',
    value: '48',
    label: 'Chirurgie Vasculaire',
    selected: true,
  },
  {
    id: '49',
    value: '49',
    label: 'Chirurgie Viscérale et Digestive',
    selected: true,
  },
  {
    id: '70',
    value: '70',
    label: 'Gynécologie Médicale',
    selected: true,
  },
  {
    id: '71',
    value: '71',
    label: 'Hématologie',
    selected: true,
  },
  {
    id: '72',
    value: '72',
    label: 'Médecine Nucléaire',
    selected: true,
  },
  {
    id: '73',
    value: '73',
    label: 'Oncologie Médicale',
    selected: true,
  },
  {
    id: '74',
    value: '74',
    label: 'Oncologie Radiothérapique',
    selected: true,
  },
  {
    id: '75',
    value: '75',
    label: 'Psychiatrie de l’enfant et de l’adolescent',
    selected: true,
  },
  {
    id: '76',
    value: '76',
    label: 'Radiothérapie',
    selected: true,
  },
  {
    id: '77',
    value: '77',
    label: 'Obstétrique',
    selected: true,
  },
  {
    id: '78',
    value: '78',
    label: 'Génétique médicale',
    selected: true,
  },
  {
    id: '79',
    value: '79',
    label: 'Obstétrique et gynécologie médicale',
    selected: true,
  },
  {
    id: '80',
    value: '80',
    label: 'Santé publique et médecine sociale',
    selected: true,
  },
  {
    id: '81',
    value: '81',
    label: 'Médecine des Maladies infectieuses et tropicales',
    selected: true,
  },
  {
    id: '82',
    value: '82',
    label: 'Médecine légale et expertises médicales',
    selected: true,
  },
  {
    id: '83',
    value: '83',
    label: 'Médecine d’urgence',
    selected: true,
  },
  {
    id: '84',
    value: '84',
    label: 'Médecine vasculaire',
    selected: true,
  },
  {
    id: '85',
    value: '85',
    label: 'Allergologie',
    selected: true,
  },
];

export const DOCTOR_COLUMNS = [
  {
    label: 'Doctor',
    accessor: 'doctorFullName',
    type: 'doctorFullName',
    isFilterable: false,
    classNames: 'th-list-sticky th-list-cellwidth-240',
    selected: true,
  },
  {
    label: 'ACCOUNT TYPE',
    accessor: 'type',
    type: 'accountType',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'SPECIALTY',
    accessor: 'specialty',
    type: 'specialty',
    options: INTELLIO_SPECIALTIES,
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
  },
  {
    label: 'ACCOUNT STATUS',
    accessor: 'status',
    type: 'accountStatus',
    isFilterable: false,
    classNames: 'th-list-cellwidth-240',
    isSortable: true,
    sortLabel: 'Account status: Active first and Creation date: Later first',
  },
];
